import React, { Component } from 'react'
import MaterialUiCheckbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'

class Checkbox extends Component {
  render() {
    const { onChange, checked, placeholder, classes, style } = this.props

    return (
      <div style={{ ...Styles.container, ...style }}>
        <MaterialUiCheckbox
          classes={{ checked: classes.checked }}
          checked={checked}
          onChange={(event, checked) => onChange(checked)}
        />
        <p>{placeholder}</p>
      </div>
    )
  }
}

const Styles = {
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  checked: {
    color: '#289e64 !important'
  }
}

export default withStyles(Styles)(Checkbox)



// WEBPACK FOOTER //
// ./src/components/common/Checkbox.js